import { useContext, useState, useEffect } from 'react'
import { ClientContext } from '../../../contexts/clientProvider'
import { AnexosContext } from '../../../contexts/anexosProvider'
import { UserContext } from '../../../contexts/userProvider';
import { anexosLinhas, linhasComponentMap } from '../../General/Format/anexo';
import { BiTrash } from 'react-icons/bi';
import BaseSelect from '../../General/FormsComp/Select/BaseSelect';

const Cadastro = () => {
    const { clientes } = useContext(ClientContext);
    const { anexosByClient, createLinha } = useContext(AnexosContext);
    const { user, setAlert } = useContext(UserContext);
    const [clients, setClients] = useState(null);
    const [anexos, setAnexos] = useState(null);
    const [linhas, setLinhas] = useState([]);
    const [anexoData, setAnexoData] = useState({});
    const [selectedClient, setSelectedClient] = useState('');
    const [selectedAnexo, setSelectedAnexo] = useState('');
    useEffect(() => {
        let newClients = clientes ? clientes : [];
        setClients(newClients);
    }, [clientes]);

    async function handleSelectClient(e) {
        const idCliente = e.target.value
        setSelectedClient(idCliente)
        setSelectedAnexo('')
        setAnexos(null)
        if (idCliente) {
            const anexos = await anexosByClient(idCliente)
            setAnexoData({ id_cliente: parseInt(idCliente) })
            setAnexos(anexos)
        } else {
            setAnexoData({})
        }
    }

    async function handleSelectAnexo(e) {
        const idAnexo = e.target.value
        setSelectedAnexo(idAnexo)
        setAnexoData({ ...anexoData, id_anexo: parseInt(idAnexo) })
    }

    const handleInputChangeLinha = (e, index) => {
        const updatedLinhas = [...linhas];
        updatedLinhas[index] = { ...updatedLinhas[index], [e.target.name]: e.target.value };
        setLinhas(updatedLinhas);
    };

    const handleAddLinha = () => {
        const newLine = { ...anexoData, id_user: user.id, created_at: new Date().toISOString().slice(0, 19).replace('T', ' '), updated_at: new Date().toISOString().slice(0, 19).replace('T', ' ') };
        setLinhas([...linhas, newLine]);
    };

    const handleSaveClick = async () => {
        if (linhas.length === 0) {
            setAlert({ visible: true, title: "Atenção!", placeholder: 'Adicione ao menos uma linha', confirm: false, type: "warning" })
            return
        }
        linhas.forEach(linha => {
            if(!linha.id_anexo || !linha.id_anexo || !linha.linha || !linha.status || !linha.operadora ) {
                setAlert({ visible: true, title: "Atenção!", placeholder: 'Preencha todos os campos obrigatórios.', confirm: false, type: "warning" });
                return;
            }
        })
        createLinha(linhas)
        setLinhas([])
        setAnexos(null)
        setAnexoData({})
        setSelectedClient('')
        setSelectedAnexo('')
        setClients(null)
    }

    const handleRemoveLinha = (index) => setLinhas([...linhas.slice(0, index), ...linhas.slice(index + 1)]);

    const componentMapLinhas = linhasComponentMap(handleInputChangeLinha);
    return (
        <div className='space-y-6' style={{ overflow: 'visible' }}>
            <div className='grid grid-cols-1 md:grid-cols-2 gap-4' style={{ overflow: 'visible' }}>
                <BaseSelect
                    label="Cliente"
                    name="cliente"
                    value={selectedClient}
                    onChange={handleSelectClient}
                    options={clients ? clients.slice().sort((a, b) => a.nome.localeCompare(b.nome)) : []}
                    placeholder="Selecione o cliente"
                    valueKey="id"
                    labelKey="nome"
                />
                
                <BaseSelect
                    label="Anexo"
                    name="anexo"
                    value={selectedAnexo}
                    onChange={handleSelectAnexo}
                    options={anexos ? anexos.slice().sort((a, b) => a.nome.localeCompare(b.nome)) : []}
                    placeholder="Selecione o anexo"
                    valueKey="id"
                    labelKey="nome"
                    disabled={!anexos}
                />
            </div>
            {anexoData.id_cliente && (
                <div className='bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-6 space-y-4'>
                    <div className='flex justify-between items-center border-b border-gray-200 dark:border-gray-700 pb-4'>
                        <h3 className='text-lg font-semibold text-gray-900 dark:text-white'>
                            Linhas do Anexo
                        </h3>
                        <button 
                            className='px-4 py-2 bg-vox-green-600 hover:bg-vox-green-700 text-white font-semibold rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-vox-green-500 focus:ring-offset-2' 
                            onClick={handleAddLinha}
                        >
                            Adicionar Linha
                        </button>
                    </div>
                    
                    {linhas.map((linha, index) => (
                        <div className="bg-gray-50 dark:bg-gray-700 rounded-lg p-4 border border-gray-200 dark:border-gray-600" key={index}>
                            <div className='flex items-start gap-4'>
                                <div className='flex-1 grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4'>
                                    {anexosLinhas(linha).map((dado, subIndex) => (
                                        <div key={subIndex}>
                                            {componentMapLinhas['Linhas']({ ...dado, index })}
                                        </div>
                                    ))}
                                </div>
                                <button 
                                    className='p-2 text-red-600 hover:text-red-800 hover:bg-red-50 rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2'
                                    onClick={() => handleRemoveLinha(index)}
                                    title="Remover linha"
                                >
                                    <BiTrash size={20} />
                                </button>
                            </div>
                        </div>
                    ))}
                    
                    {linhas.length > 0 && (
                        <div className='flex justify-end pt-4 border-t border-gray-200 dark:border-gray-700'>
                            <button 
                                className='px-6 py-3 bg-vox-blue-600 hover:bg-vox-blue-700 text-white font-semibold rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-vox-blue-500 focus:ring-offset-2' 
                                onClick={handleSaveClick}
                            >
                                Salvar Linhas
                            </button>
                        </div>
                    )}
                </div>
            )}
        </div>
    )
}

export default Cadastro
